export default __webpack_public_path__ + "static/2-7171c1eb1dfb9b629ab2e884796591cb.png";